import { Box, CircularProgress, Stack, Typography, useTheme } from '@mui/material';
import NProgress from 'nprogress';
import { useEffect } from 'react';
import appConfig from 'src/config/appConfig';

interface Props {
  message?: string;
}

function SuspenseLoader({ message }: Props) {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'fixed',
        left: 0,
        top: 0,

        height: '100%',
        width: '100%',
        [theme.breakpoints.up(appConfig.breakMobileView)]: {
          ml: theme.sidebar.width,
          width: `calc(100% - ${theme.sidebar.width})`,
        },
      }}
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <Stack justifyContent='center' alignItems='center' spacing={2}>
        <CircularProgress size={64} disableShrink thickness={3} />
        <Typography variant='h2'>{message}</Typography>
      </Stack>
    </Box>
  );
}

export default SuspenseLoader;
